<template>
  <v-container fluid>
    <template>
      <v-breadcrumbs :items="link">
        <template v-slot:link="{ link }">
          <v-breadcrumbs-item :href="link.href" :disabled="link.disabled">
            {{ link.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </template>
    <v-sheet class="mx-auto">
      <v-slide-group multiple show-arrows>
        <v-slide-item>
          <v-row>
            <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale victime ..." class="pt-5 pa-2"
              v-model="thirdName" @change="onEnter" prepend-inner-icon="mdi-magnify" dense flat
              background-color="grey lighten-4"></v-text-field>
            <v-text-field outlined color="#0482fb" label="Contact victime ..." class="pt-5 pa-2" @change="onEnter"
              v-model="thirdPartyContact" prepend-inner-icon="mdi-magnify" dense flat
              background-color="grey lighten-4"></v-text-field>
          </v-row>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <v-data-table :headers="headers" :items="Victims" class="elevation-0">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing personnes indemnisables </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="1000px">
            <template v-slot:activator="{}">
              <v-btn color="#0482fb" pill dark @click="addVictim">
                Ajout victime
              </v-btn>
              <v-btn color="error" class="mr-4" pill dark @click="printDeclaration = true">
                FORMULAIRE DE DECLARATION SINISTRE
              </v-btn>
            </template>
            <v-card style="border-top: 10px solid #0482fb">
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field outlined color="#0482fb" v-model="victimModal.thirdName"
                        label="Nom victime"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field outlined color="#0482fb" v-model="victimModal.thirdPartyContact"
                        label="Contact victime"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field outlined color="#0482fb" v-model="victimModal.thirdPartyBodilyInjury"
                        label="Dommage corporels"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field outlined color="#0482fb" v-model="victimModal.thirdPartyMaterialDamage"
                        label="Dommage matériels"></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-combobox v-model="victimModal.mailNumbersDeclarationSinistre" clearable
                        label="Numéro courrier arrivée" multiple outlined color="#0482fb" background-color="#cbf3f0">
                        <template v-slot:selection="{ attrs, item, select, selected }">
                          <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                            @click:close="remove(item)">
                            <strong>{{ item }}</strong>

                          </v-chip>
                        </template>
                      </v-combobox>

                    </v-col>
                    <v-col cols="12">
                      <v-textarea outlined v-model="victimModal.observation" name="input-7-4"
                        label="Observation "></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="close">
                  Retour
                </v-btn>
                <v-btn color="success" :loading="loading ? '#0482fb' : null" class="ml-5" @click="saveVictim">
                  Enregistrer
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément
                ?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- <template v-slot:item.actions="{ item }">
        <v-icon color="warning" @click="editItem(item)">
          mdi-pencil-box-multiple-outline
        </v-icon>
        <v-icon
          class="ml-10"
          size="30"
          color="success"
          @click="selectVictim(item)"
        >
          mdi-arrow-right-circle-outline
        </v-icon>
      </template> -->

      <template v-slot:item.actions="{ item }">
        <v-menu elevation="0" right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="selectVictim(item)" v-bind="attrs" v-on="on" class="mr-10">
              <v-icon color="success" size="30">mdi-forwardburger</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-tooltip bottom color="pink">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGed(item)" v-bind="attrs" v-on="on"
                    color="pink">mdi-file-table-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers </span>
            </v-tooltip>
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on"
                    color="warning">mdi-pencil-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Modification des informations de la victime</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="productDialog = true" color="success" v-bind="attrs"
                    v-on="on">mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion pièces</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" v-bind="attrs" v-on="on" @click="expertiseDialog = true">mdi-school</v-icon>
                </v-btn>
              </template>
              <span>Expertise</span>
            </v-tooltip>

            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon @click="bonsDialog = true" v-bind="attrs" v-on="on" size="20"
                    color="primary">mdi-ticket-percent-outline</v-icon>
                </v-btn>
              </template>
              <span>Bon</span>
            </v-tooltip>

            <v-tooltip bottom color="blue-grey">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon @click="pvDialog = true" v-bind="attrs" v-on="on" size="20"
                    color="blue-grey">mdi-police-badge</v-icon>
                </v-btn>
              </template>
              <span>PV</span>
            </v-tooltip>
            <v-tooltip bottom color="brown">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon @click="offresDialog = true" v-bind="attrs" v-on="on" size="20"
                    color="brown">mdi-alarm-panel-outline</v-icon>
                </v-btn>
              </template>
              <span>Règlement</span>
            </v-tooltip>
            <v-tooltip bottom color="purple">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon @click="print = true" v-bind="attrs" v-on="on" size="20"
                    color="purple">mdi-book-education</v-icon>
                </v-btn>
              </template>
              <span>Fiche d'avis technique</span>
            </v-tooltip>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <template>
      <h2 class="mt-5 mb-5 ml-4">Informations Déclaration</h2>
      <v-form v-model="valid">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.sinisterAskNumber" label="Numéro sinistre DAYO"
                disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.sinisterCompanyNumber"
                label="Numéro sinistre compagnie" disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.dateOfOccurrenceFr" disabled
                label="Date de survenance"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.declarationDateFr" disabled
                label="Date de déclaration"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.contract.file.name" disabled
                label="Nom du client"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" v-model="Declaration.contract.file.nature" disabled
                label="Nature"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.contract.file.phone" disabled
                label="Téléphone"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.contract.file.email" disabled
                label="Mail"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.contract.customerNumber" disabled
                label="Numéro client"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.contract.policeNumber" disabled
                label="Numéro police"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.contract.plugged" disabled
                label="Numéro Quitance"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.PSAP" disabled label="PSAP"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.disasterObject" disabled
                label="Objet sinistré"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined color="#0482fb" :value="Declaration.circumstance" disabled
                label="Circonstance"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field outlined color="#0482fb" :value="Declaration.observation" disabled
                label="Observations"></v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="4">
              <v-text-field outlined  
            color="#0482fb"
                disabled
                v-model="firstName"
                label="Autres détaille ..."
              ></v-text-field>
            </v-col> -->
          </v-row>
        </v-container>
      </v-form>
    </template>
    <!--impression document -->
    <template>
      <v-dialog v-model="printDeclaration" width="1000px">
        <v-card style="border-top: 10px solid #0482fb">
          <section style="margin-right:50px;margin-left:50px; padding-bottom:50px;padding-top:50px;">
            <v-row>
              <v-tab>FORMULAIRE DE DECLARATION SINISTRE</v-tab>
              <v-spacer></v-spacer>
              <v-btn color="error" class="mt-5 ml-2 mr-2 white--text" :loading="loading ? '#0482fb' : null" pill
                @click="generateReport()">Imprimer sous format PDF</v-btn>
            </v-row>
            <div id="document" ref="document">
              <div>
                <img src="../assets/logo.jpg" alt="DAYO Gras Savoye" width="150" height="70" />
              </div>
              <br />
              <br />
              <br />
              <div style="
                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  margin: auto auto;
                  font-size: 8px;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  color: #0482fb;
                  margin-top: 5px;
                ">
                <h1>ATTESTATION DE DECLARATION SINISTRE</h1>
              </div>
              <br />
              <p style="text-align:justify;   ">
                CHER(E) CLIENT(E)
                <b>{{ this.Declaration.contract.file.name }}</b><br /><br />
                Nous avons pris bonne note de votre déclaration de sinistre.<br /><br />
                Votre dossier enregistré sous le numéro
                <b>{{ this.Declaration.sinisterAskNumber }}</b>
                sera donc traité avec diligence. Vous voudriez bien nous
                rappeler ce numéro dans toutes vos correspondances à ce sujet ou
                lors de votre visite à nos bureaux. <br /><br />
                Déclaration du
                <b>{{ this.Declaration.declarationDateFr }}</b><br />
                <br />
                Merci.
              </p>
              <br />
              <br />
              <div style="
                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  margin: auto auto;
                  font-size: 8px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  color: white;
                  margin-top: 5px;
                ">
                <h1>FICHE DE DECLARATION SINISTRE</h1>
              </div>
              <table style="
                  font-family: Arial, Helvetica, sans-serif;
                  border-collapse: collapse;
                " border="1">
                <tbody>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      N° sinistre
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                      ">
                      {{ this.Declaration.sinisterAskNumber }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Nom Rédacteur
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif;font-size: 11px; padding: 5px">
                      {{
                        defaultMethods.getItemName(
                          this.Users.docs,
                          this.Declaration.createdBy
                        )
                      }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Date survenance
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.dateOfOccurrenceFr }}
                    </td>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Client
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        this.Declaration.contract &&
                          this.Declaration.contract.file.name
                          ? this.Declaration.contract.file.name
                          : ""
                      }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Effet
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        this.Declaration.contract &&
                          this.Declaration.contract.effectDateFr
                          ? this.Declaration.contract.effectDateFr
                          : ""
                      }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Echéance
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        this.Declaration.contract &&
                          this.Declaration.contract.dueDateFr
                          ? this.Declaration.contract.dueDateFr
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Objet Sinistré
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.disasterObject }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      PSAP
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.PSAP }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Date déclaration
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.declarationDateFr }}
                    </td>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      N° Police
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        this.Declaration.contract &&
                          this.Declaration.contract.policeNumber
                          ? this.Declaration.contract.policeNumber
                          : ""
                      }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Produit
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        defaultMethods.getItemName(
                          this.Products.docs,
                          this.Declaration.contract &&
                            this.Declaration.contract.product
                            ? this.Declaration.contract.product
                            : ""
                        )
                      }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Catégorie
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{
                        this.Declaration.contract &&
                          this.Declaration.contract.category
                          ? this.Declaration.contract.category
                          : "..."
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Garantie
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      ...
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Nom du conducteur
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.driverName }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Contact conducteur
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px">
                      {{ this.Declaration.conductiveContact }}
                    </td>
                  </tr>
                  <tr>
                    <th style="                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  font-size: 11px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  border-color:#0482fb;
                  color: white;" colspan="8">
                      CIRCONSTANCES DETAILLEES DU SINISTRE
                    </th>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 20px;
                        text-align: center;
                        text-align:justify;
                      " colspan="8">
                      {{ this.Declaration.circumstance }}
                    </td>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Dommages matériels Assuré
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px" colspan="2">
                      {{ this.Declaration.materialDamageInsured }}
                    </td>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 5px;
                        width: 16%;
                        font-size: 11px;
                        font-weight: 700;
                      ">
                      Dommages Corporels Assuré
                    </td>
                    <td style="font-family: Arial, Helvetica, sans-serif; font-size: 11px; padding: 5px" colspan="2">
                      {{ this.Declaration.insuredBodilyInjury }}
                    </td>
                  </tr>

                  <tr>
                    <th style="                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  font-size: 11px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  border-color:#0482fb;
                  color: white;" colspan="8">
                      RENSEIGNEMENTS TIERS
                    </th>
                  </tr>
                  <tr>
                    <td style="
                        font-family: Arial, Helvetica, sans-serif;
                        padding: 20px;
                        text-align: center;
                        text-align:justify;
                      " colspan="8">
                      {{ this.Declaration.observation }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </v-card>
      </v-dialog>
    </template>

    <!--  Déclaration Expertise-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="expertiseDialog" overlay max-width="500px" transition="dialog-bottom-transition"
            scrollable>
            <v-card style="border-top:10px solid #0482fb " tile>
              <v-card-text>
                <h2 class="pt-8 pl-3">Expertise</h2>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="expertiseModal.dateRequestExpertise" type="date"
                        label="Date demande expertise"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="expertiseModal.reportReceptionDate" type="date"
                        label="Date réception rapport"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field outlined color="#0482fb" v-model="expertiseModal.expertName"
                        label="Nom Expert"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="expertiseModal.observation" name="input-7-4" label="Observation"
                        value=""></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>

                <v-row align="center" justify="end">
                  <v-btn tile color="error" text @click="expertiseDialog = false">
                    Fermer
                  </v-btn>
                  <v-btn tile color="success" class="ml-5" @click="saveExpertise">
                    Enregistrer
                  </v-btn>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <v-dialog v-model="addFileMailGed" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <!--  Déclaration Bon-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="bonsDialog" overlay max-width="500px" transition="dialog-bottom-transition" scrollable>
            <v-card style="border-top:10px solid #0482fb " tile>
              <v-card-text>
                <h2 class="pt-8 pl-3">Bon</h2>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="couponModal.requestDate" type="date"
                        label="Date demande"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="couponModal.couponReceptionDate" type="date"
                        label="Date récption Bon"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-text-field outlined color="#0482fb" v-model="couponModal.amount"
                        label="Montant Bon"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="couponModal.observation" name="input-7-4" label="Observation"
                        value=""></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <v-row align="center" justify="end">
                  <v-btn tile color="error" text @click="bonsDialog = false">
                    Fermer
                  </v-btn>
                  <v-btn tile color="success" class="ml-5" @click="saveCoupon">
                    <v-icon left> mdi-pencil </v-icon>
                    Enregistrer
                  </v-btn>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>

    <!--  Déclaration PV-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="pvDialog" overlay max-width="500px" transition="dialog-bottom-transition" scrollable>
            <v-card style="border-top:10px solid #0482fb " tile>
              <v-card-text>
                <h2 class="pt-8 pl-3">Procès-Verbal</h2>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="pvModal.requestDatePv" type="date"
                        label="Date demande PV"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="pvModal.policeStation"
                        label="Commissariat"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="pvModal.receptionDatePv" type="date"
                        label="Date réception PV"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field outlined color="#0482fb" v-model="pvModal.locality" label="Localité"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="pvModal.observation" name="input-7-4" label="Observation"
                        value=""></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <v-row align="center" justify="end">
                  <v-btn tile color="error" text @click="pvDialog = false">
                    Fermer
                  </v-btn>
                  <v-btn tile color="success" class="ml-5" @click="savePv">
                    Enregistrer
                  </v-btn>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>

    <!--  Déclaration Offres-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="offresDialog" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
            <v-card style="border-top:10px solid #0482fb ">
              <v-card-text>
                <h2 class="pt-8 pl-3">Règlement</h2>
                <v-container fluid>
                  <v-row align="center">
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.PSAP" label="PSAP"
                        type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.inGameWarranty"
                        label="Garantie en jeu"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.documentSendDate"
                        label="Date envoi pièces" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.offerReceptDate"
                        label="Date réception offre" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.amount" label="Montant Offre"
                        type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.offerSendDate"
                        label="Date envoi de l'offre" type="date"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.aggreementReceptDate"
                        label="Date réception Accord" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.agreementTransmissionDate"
                        label="Date transmission Accord" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.checkReceiptDate"
                        label="Date réception Chèque" type="date"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.checkTransmissionDate"
                        label="Date transmission chèque" type="date"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.receptDateReturn"
                        label="Date retour quittance" type="date"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3">
                      <v-select outlined :items="offreStatut" v-model="offerModal.status" label="Statut"></v-select>
                    </v-col>
                    <!-- 
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.amount"
                                  
                                  label="Montant Offre"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.customerAgreementTransmissionDate"
                                  type="date"
                                  label="Date transmission accord client"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.dateAgreement"
                                  type="date"
                                  label="Date Accord"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.checkReceiptDate"
                                  type="date"
                                  label="Date Réception chèque"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.checkTransmissionDate"
                                  type="date"
                                  label="Date Transmission chèque"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.receptDateReturn"
                                  type="date"
                                  label="Date Retour Quitance"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="4">
                                <v-text-field outlined  
            color="#0482fb"
                                  v-model="offerModal.status"
                                  label="Statut"
                                ></v-text-field>
                              </v-col> -->
                    <v-col cols="12" md="12">
                      <v-textarea outlined v-model="offerModal.observation" name="input-7-4" rows="2"
                        label="Observation" value=""></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.franchise" label="Franchise"
                        type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.honorary" label="Honoraire"
                        type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.checkNumber" label="Numéro chèque"
                        type="number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field outlined color="#0482fb" v-model="offerModal.bank" label="Banque"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <v-row align="center" justify="end">
                  <v-btn tile color="error" text @click="offresDialog = false">
                    Fermer
                  </v-btn>
                  <v-btn tile color="success" class="ml-5" @click="saveOffer">
                    Enregistrer
                  </v-btn>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>

    <!--  Pop up des produits-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="productDialog" overlay transition="dialog-bottom-transition" scrollable max-width="1500px">
            <v-card style="border-top: 10px solid #0482fb;" tile>
              <!-- {{ victimModal.otherInfo.documentsProvides }} -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="4">
                    <h3 class="mt-5 ml-2">
                      DAYO - IARD / sinistre / Gestion pièces
                    </h3>
                    <v-text-field outlined color="#0482fb" label="Recherche" class="pt-5 "
                      prepend-inner-icon="mdi-magnify" dense v-model="searchData" @change="searchDataProduct" flat
                      background-color="grey lighten-4"></v-text-field>
                    <!-- <h3 class="mb-5">
                                Sélectionner les pièces à fournir
                              </h3> -->
                    <v-data-table v-model="selectedDocumentsModal" :headers="headersProduct" :items="Documents"
                      item-key="_id" :items-per-page="5" show-select class="elevation-0">
                    </v-data-table>
                    <div class="mt-2">
                      <v-btn class="white--text" color="#0482fb" :loading="loading ? '#0482fb' : null"
                        @click="proposedDocuments">Réclamer les pièces sélectionnées</v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div style="margin-top:129px !important"></div>
                    <!-- <h3 class="mb-5">Liste des pièces à fournir</h3> -->
                    <v-data-table v-model="selectedProduct" :headers="headersProducts" :items="documentsProvides"
                      item-key="_id" :items-per-page="5" show-select class="elevation-0">
                    </v-data-table>
                    <div class="mt-2">
                      <v-btn class="white--text" color="#0482fb" :loading="loading ? '#0482fb' : null"
                        @click="providedDocuments">Valider les pièces fournies</v-btn>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div style="margin-top:129px !important"></div>
                    <!-- <h3 class="mb-5">Liste des pièces fournies</h3> -->
                    <v-data-table :headers="headersProductss" :items="documentsAlreadyProvides" class="elevation-0"
                      items-per-page="5">
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>

              <div style="flex: 1 1 auto"></div>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!--Avis Technique -->
    <template>
      <v-dialog v-model="avisTechnique" max-width="1000px">
        <v-card style="border-top:10px solid #0482fb ">
          <v-card-title>
            <span class="text-h5">Avis technique</span>
          </v-card-title>
          <v-col cols="12">
            <quill-editor ref="editor" v-model="victimModal.technicalObservation" class="mt-5"
              :options="editorOption" />
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="avisTechnique = false">
              Fermer
            </v-btn>
            <v-btn depressed large @click="saveVictim" color="success">
              Ajouter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!--impression document -->
    <template>
      <div class="justify-center">
        <v-dialog v-model="print" max-width="1000px">
          <v-card style="border-top:10px solid #0482fb ">
            <section style="margin-right:50px;margin-left:50px; padding-bottom:50px;padding-top:50px;">
              <v-row>
                <v-tab>FICHE D'AVIS TECHNIQUE</v-tab>

                <v-spacer></v-spacer>
                <v-btn color="#0482fb" class="mt-5 ml-2 mr-2 " elevation="0" :loading="loading ? '#0482fb' : null" pill
                  @click="avisTechnique = true">Compléter Avis Technique</v-btn>
                <v-btn color="error" class="mt-5 ml-2 mr-2 " elevation="0" :loading="loading ? '#0482fb' : null" pill
                  @click="generateReports()">Imprimer sous format PDF</v-btn>
              </v-row>

              <div id="document" ref="documents">
                <div>
                  <img src="../assets/logo.jpg" alt="DAYO Gras Savoye" width="150" height="70" />
                </div>
                <br />
                <br />
                <br />
                <div style="
                    font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  margin: auto auto;
                  font-size: 8px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  color: white;
                  margin-top: 50px;
                    ">
                  <h1>
                    FICHE D'AVIS TECHNIQUE :
                    <b>{{ this.allVictimeInfo.thirdName }}</b>
                  </h1>
                </div>
                <table style="
                      font-family: Arial, Helvetica, sans-serif;
                      border-collapse: collapse;
                      width:100%;
                    " border="1">
                  <tbody>
                    <tr>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        N° sinistre
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{ this.allInfoDeclaration.sinisterCompanyNumber }}
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Nom Rédacteur
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{
                          defaultMethods.getItemName(
                            this.Users.docs,
                            this.allVictimeInfo.createdBy
                          )
                        }}
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Date survenance
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{ this.allInfoDeclaration.dateOfOccurrenceFr }}
                      </td>
                    </tr>
                    <tr>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Client
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{
                          this.allInfoDeclaration.contract &&
                            this.allInfoDeclaration.contract.file.name
                            ? this.allInfoDeclaration.contract.file.name
                            : ""
                        }}
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Effet
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{
                          this.allInfoDeclaration.contract &&
                            this.allInfoDeclaration.contract.effectDateFr
                            ? this.allInfoDeclaration.contract.effectDateFr
                            : ""
                        }}
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Echéance
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{
                          this.allInfoDeclaration.contract &&
                            this.allInfoDeclaration.contract.dueDateFr
                            ? this.allInfoDeclaration.contract.dueDateFr
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        Objet Sinistré
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{ this.allInfoDeclaration.disasterObject }}
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            padding: 5px;
                            width: 16%;
                            font-size: 11px;
                        font-weight: 700;
                          ">
                        PSAP
                      </td>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                          ">
                        {{
                          this.allVictimeInfo.otherInfo &&
                            this.allVictimeInfo.otherInfo.offer
                            ? this.allVictimeInfo.otherInfo.offer.PSAP
                            : "....."
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th style="                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  font-size: 11px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  border-color:#0482fb;
                  color: white;" colspan="8">
                        CIRCONSTANCES DETAILLEES DU SINISTRE
                      </th>
                    </tr>
                    <tr>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                            font-size: 11px; padding: 5px;
                           
                            text-align: justify;
                          " colspan="8">
                        {{ this.allInfoDeclaration.circumstance }}
                      </td>
                    </tr>
                    <tr>
                      <th style="                  font-family: Arial, Helvetica, sans-serif;
                  text-align: center;
                  font-size: 11px;
                  background-color: #0482fb;
                  padding-top: 5px;
                  padding-bottom: 5px;
                  border-color:#0482fb;
                  color: white;" colspan="8">
                        Avis TECHNIQUE
                      </th>
                    </tr>
                    <tr>
                      <td style="
                            font-family: Arial, Helvetica, sans-serif;
                          font-size: 11px; padding: 5px;
                            text-align: justify;
                          " colspan="8" v-html="allVictimeInfo.technicalObservation"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages, rules } from "@/utils/data";
//import pdfFile from "../exportDoc/pdf.vue";
import {
  addAppointment,
  // updateFile,
  createVictim,
  updateVictim,
  updateAppointment,
  addQuoting,
  updateQuoting,
  // updateContract,
  addContract,
  addIncorporation,
  withdrawProspect,
  addRegulationClause,
  updateRegulationClause,
  addPbClause,
  updatePbClause,
  manageCoupon,
  manageExpertise,
  managePv,
  manageOffer,
  manageDocumentProposed,
} from "@/api/user.js";
import { updateFile } from "@/api/admin.js";
import html2pdf from "html2pdf.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
export default {
  name: "production",
  components: { quillEditor },

  data() {
    return {
      defaultMethods,
      pdfUse: false,
      reminderMenu: false,
      companyRequestMenu: false,
      addFileMailGed: false,
      filesListe: [],
      companyReturnMenu: false,
      customerRequestMenu: false,
      customerReturnMenu: false,
      rules,
      victimsId: "",
      print: false,
      printDeclaration: false,
      switch1: true,
      panel: [],
      tab: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",

        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
      garantietitre: [
        {
          tab: "RESPONSABILITE CIVILE CHEF D'ENTREPRISE",
          content: "Tab 1 Content",
        },
        { tab: "MULTIRISQUE PROFESSIONNELLE", content: "Tab 2 Content" },
        { tab: "GLOBAL DE BANQUE BOA", content: "Tab 3 Content" },
        { tab: "MULTIRISQUE HABITATION", content: "Tab 4 Content" },
        { tab: "TRC", content: "Tab 5 Content" },
        { tab: "IND", content: "Tab 6 Content" },
      ],
      items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
      link: [
        {
          text: "Sinistre",
          disabled: false,
          href: "/sinistre",
        },
        {
          text: "Gestion dossier",
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
      offreStatut: ["Suspens", "Soldé", "Sans suite", "Recours", "Prescrit"],
      natureprospect: ["Physics", "Entreprise"],
      focus: "",
      search: "",
      partLists: [],
      partsListSupplied: [],
      partsSupplied: [],
      events: [],
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      regulation: false,
      PB: false,
      coassurance: false,
      reassurance: false,
      select: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      avisTechnique: false,
      colors: ["red"],
      names: ["Appel"],
      colorss: ["green"],
      namess: ["Rendez vous"],
      categories: ["John Smith"],
      addgarantie: false,
      dialog: false,
      appelsModal: false,
      callDialog: false,
      appointmentAddDialog: false,
      appointmentDialog: false,
      productDialog: false,
      quotingDialog: false,
      garantie: false,
      contractDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      quotingModal: {},
      prospect: false,
      dialogDelete: false,
      categoriegarantie: [
        {
          titreCatégorie: "I- Responsabilité Civile Exploitation",

          Souscategoriegarantie: [
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
            {
              titreCatégorie: "domage",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "II- Responsabilité Civile Professionnelle",

          Souscategoriegarantie: [
            {
              titreCatégorie: "Domage1",
              value1: "",
              value2: "",
            },
          ],
        },
        {
          titreCatégorie: "III- Défense et Recours",
          value1: "10 000 000",
          value2: "Néant",
        },
      ],
      produitsugest: [
        {
          text: " Liste des produits",
          value: "name",
        },
      ],
      produittake: [
        {
          text: "Liste des produits Proposer",
          value: "nom",
        },
      ],
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        {
          text: "Nom victime",
          align: "start",
          sortable: false,
          value: "thirdName",
        },
        { text: "Contact victime", value: "thirdPartyContact" },
        { text: "Dommages corporels", value: "thirdPartyBodilyInjury" },
        { text: "Dommages matériels", value: "thirdPartyMaterialDamage" },
        { text: "Observation", value: "observation" },
      ],
      victimeData: [
        {
          thirdName: "POPO Jean",
          thirdPartyContact: "0225544",
          thirdPartyBodilyInjury: "65000",
          thirdPartyMaterialDamage: "95000",
          observations: "Ils se plain de tout; il étonne même",
        },
      ],
      compagnireturnehead: [
        {
          text: "Compagnie",
          align: "start",
          sortable: false,
          value: "fullName",
        },
        { text: "Prime nette", value: "activityField" },
        { text: "Prime TTC", value: "email" },
        { text: "Accessoire", value: "email" },
        { text: "Date retour", value: "contact" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersCouriers: [
        {
          text: "Numéro courrier",
          align: "start",
          sortable: false,
          value: "fullName",
        },
        // { text: "Nature", value: "nature" },
        // { text: "Description", value: "description" },
        { text: "Date arrivé", value: "activityField" },
        { text: "Date affectation", value: "email" },
        { text: "Date traitement", value: "contact" },
        { text: "Observation", value: "birthday" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersOffres: [
        {
          text: "Date réception offre",
          align: "start",
          sortable: false,
          value: "fullName",
        },
        // { text: "Nature", value: "nature" },
        // { text: "Description", value: "description" },
        { text: "Montant offre", value: "activityField" },
        { text: "Date transmission accord client", value: "email" },
        { text: "Date accord", value: "contact" },
        { text: "Date réception chèque", value: "birthday" },
        { text: "Date transmission chèque", value: "location" },
        { text: "Date retour quittance", value: "location" },
        { text: "Observation", value: "location" },
        { text: "Statut", value: "location" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      Avenantheaders: [
        {
          text: "Date Opération",
          align: "start",
          sortable: false,
          value: "createdAt",
        },
        // { text: "Nature", value: "nature" },
        // { text: "Description", value: "description" },
        { text: "Type avenant", value: "type" },
        { text: "Numéro Police", value: "policeNumber" },
        { text: "Effet", value: "effectDate" },
        { text: "Echéance", value: "dueDate" },
        { text: "Prime nette", value: "netPrime" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
      listproduit: [
        {
          name: "Cart d'identité",
        },
        {
          name: "permis de conduit",
        },
        {
          name: "Atestation de residence",
        },
      ],
      prospectdata: [],
      editedIndex: -1,
      editedItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      defaultItem: {
        nom: "",
        Nature: "",
        Contact: "",
        Activité: "",
        Mail: "",
        Anniverssaire: "",
        Localisation: "",
      },
      incorporationDialog: false,
      withDrawModal: false,

      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
        },
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
        },
      ],
      sinisterDialog: false,
      expertiseDialog: false,
      victimDialog: false,
      bonsDialog: false,
      pvDialog: false,
      courierDialog: false,
      offresDialog: false,
      coinsuranceDialog: false,
      reasure: false,
      returnCompagn: false,
      regulationDialog: false,
      pbDialog: false,
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is ",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      callModal: {},
      appointmentModal: {},
      appointmentEvents: [],
      productNameList: [],
      loading: false,
      valid: false,
      firstName: "",

      headersProduct: [
        {
          text: "Sélectionner les pièces à fournir",
          align: "start",
          sortable: false,
          value: "name",
        },
      ],
      headersProducts: [
        {
          text: "Liste des pièces à fournir",
          align: "start",
          sortable: false,
          value: "name",
        },
      ],
      headersProductss: [
        {
          text: "Liste des pièces fournies",
          align: "start",
          sortable: false,
          value: "name",
        },
      ],
      selectedProduct: {},
      currentProduct: null,
      avenantList: [
        "Affaire Nouvelle",
        "Renouvellement",
        "Incorporation",
        "Retrait",
        "Suspension",
        "Remise en vigeur",
        "Precision",
        "Modification",
        "Resiliation",
        "Régularisation",
        "Changement d'immatriculation",
      ],
      proposedProductNameList: [],
      companyNameList: [],
      coinsuranceCompanyNameList: [],
      CommercialNameList: [],
      prospectsNameList: [],

      contractModal: {
        accessory100: 0,
        accessory50: 0,
      },
      incorporationModal: {},
      regulationClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },
      pbClauseModal: {
        reminderDate: "",
        companyRequestDate: "",
        companyReturnDate: "",
        customerRequestDate: "",
        customerReturnDate: "",
      },

      coinsuranceModal: [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ],
      victimModal: {},
      couponModal: {},
      allInfo: [],
      allInfoDeclaration: [],
      allVictimeInfo: [],
      expertiseModal: {},
      pvModal: {},
      offerModal: {},
      offerDialog: false,
      documentNameList: [],
      selectedDocumentsModal: [],
      documentsProvides: {},
      documentsAlreadyProvides: [],
    };
  },

  mounted() {
    this.initDeclaration();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters([
      "File",
      "Products",
      "Companies",
      "Quoting",
      "Users",
      "Contract",
      "Victims",
      "Victime",
      "Declaration",
      "Documents",
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Enregistrement victime"
        : "Modifier informations victime";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    victimDialog() {
      if (this.victimDialog == false) {
        this.closeVictim();
      }
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
    Declaration() {
      this.initVictims();
    },

    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      this.seedCoinsuranceCompanyNameList();
    },
    Users() {
      this.CommercialNameList = defaultMethods.getNameList(this.Users.docs);
    },
    Documents() {
      this.documentNameList = defaultMethods.getNameList(this.Documents);
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    currentProduct() {
      if (this.currentProduct !== null) {
        // get quoting

        // get contract
        this.seedContract();
      }
    },

    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        this.contractModal.commercial = defaultMethods.getItemName(
          this.Users.docs,
          this.contractModal.commercial
        );

        this.contractModal.dueDate = defaultMethods.getDateFormat(
          this.contractModal.dueDate
        );
        this.contractModal.effectDate = defaultMethods.getDateFormat(
          this.contractModal.effectDate
        );
        this.contractModal.paymentDate = defaultMethods.getDateFormat(
          this.contractModal.paymentDate
        );

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
  },

  methods: {
    ...mapActions([
      "getFile",
      "getProducts",
      "getCompanies",
      "getQuoting",
      "getUsers",
      "getContract",
      "getDeclaration",
      "getFileEndorsement",
      "getVictims",
      "getVictim",
      "getDocuments",
      "getVictimsSearch",
    ]),

    generateReport() {
      html2pdf(this.$refs.document, {
        margin: 0.3,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          scrollX: 0,
          scrollY: 0,
        },

        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
    },
    generateReports() {
      html2pdf(this.$refs.documents, {
        margin: 0.3,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
    },
    async makeSearchContract() {
      this.loading = true;

      try {
        await this.getVictimsSearch({
          thirdName: this.thirdName,
          thirdPartyContact: this.thirdPartyContact,
          declarationId: this.Declaration._id,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les sinistres")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    async initFileEndorsement() {
      if (this.File && this.File._id) {
        await this.getFileEndorsement({
          id: this.File._id,
        });
      }
    },
    async initVictims() {
      this.loading = true;
      try {
        await this.getVictims({
          id: this.Declaration._id,
        });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les victimes")
        );
      }
      this.loading = false;
    },
    addVictim() {
      this.victimModal = {};
      this.dialog = true;
    },
    editeVictim() {
      this.victimModal = {};
      this.dialog = true;
    },

    async saveVictim() {
      this.loading = true;

      try {
        const schema = {
          thirdPartyMaterialDamage: this.victimModal.thirdPartyMaterialDamage,
          thirdPartyBodilyInjury: this.victimModal.thirdPartyBodilyInjury,
          thirdName: this.victimModal.thirdName,
          thirdPartyContact: this.victimModal.thirdPartyContact,
          mailNumbersDeclarationSinistre: this.victimModal.mailNumbersDeclarationSinistre,
          observation: this.victimModal.observation,
          technicalObservation: this.victimModal.technicalObservation,
          // file: this.File._id,
        };

        if (this.victimModal._id) {
          await updateVictim({ schema, id: this.victimModal._id });

          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Victime")
          );
        } else {
          // add
          await createVictim({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Victime")
          );
        }

        this.closeVictim();
        this.initVictims();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeVictim() {
      this.dialog = false;
      this.avisTechnique = false;
    },
    async initDeclaration() {
      this.loading = true;
      try {
        await this.getDeclaration({
          id: this.$route.params.id,
        });
        await this.getProducts({ name: this.searchData });
        await this.getUsers();
        await this.getDocuments({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("Declaration")
        );
      }
      this.loading = false;
    },
    // files
    async initFile() {
      this.loading = true;
      try {
        await this.getFile(this.$route.params.id);
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
        await this.getUsers();
        this.initFileEndorsement();
        this.seedContract();
        // await this.getFileEndorsement({
        //   id:this.$route.params.id
        // });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    initialize() {
      console.log("ok");
    },
    closeCall() {
      this.callModal = {};
      this.callDialog = false;
      this.appelsModal = false;
    },
    editItem(item) {
      this.victimModal = "";
      this.editedIndex = 1;
      this.victimModal = Object.assign({}, item);
      this.dialog = true;
    },
    seedDoc(data, isProvide = undefined) {
      const result = [];
      if (isProvide == undefined) {
        for (let i = 0; i < data.length; i++) {
          result.push({
            _id: data[i]._id,
            name: data[i].name,
          });
        }
      } else {
        for (let i = 0; i < data.length; i++) {
          if (isProvide == data[i].isProvide) {
            result.push({
              _id: data[i]._id,
              name: data[i].name,
            });
          }
        }
      }
      return result;
    },
    pdf() {
      this.pdfUse = true;
    },
    initModalSinister() {
      (this.allInfo = []),
        (this.allInfoDeclaration = []),
        (this.allVictimeInfo = []),
        (this.couponModal = []),
        (this.pvModal = []),
        (this.expertiseModal = []),
        (this.offerModal = []),
        (this.documentsProvides = []),
        (this.selectedDocumentsModal = []),
        (this.selectedProduct = []);
    },
    getOneVictimInfo() {
      try {
        return new Promise((resolve, reject) => {
          this.getVictim({ id: this.victimsId })
            .then((res) => {
              resolve(true);
              this.victimModal = Object.assign({}, this.Victime);
              if (this.Victime.otherInfo) {
                this.allInfo = this.Victime.otherInfo ?this.Victime.otherInfo: [];
                this.allInfoDeclaration = this.Declaration ?this.Declaration: [];
                this.allVictimeInfo = this.victimModal;
                this.couponModal = this.Victime.otherInfo.coupon ?this.Victime.otherInfo.coupon: {};
                this.pvModal = this.Victime.otherInfo.pv ?this.Victime.otherInfo.pv: {};
                this.expertiseModal = this.Victime.otherInfo.expertise ?this.Victime.otherInfo.expertise: {};
                this.offerModal = this.Victime.otherInfo.offer ?this.Victime.otherInfo.offer: {};
                this.documentsProvides =
                  this.Victime.otherInfo.documentsProvides ?this.Victime.otherInfo.documentsProvides: [];
                // this.documentsProvides = item.otherInfo.documentsProvides ?? [];

                if (this.documentsProvides != []) {
                  this.selectedDocumentsModal = this.documentsProvides;
                  this.documentsAlreadyProvides = this.seedDoc(
                    this.documentsProvides,
                    true
                  );
                  this.selectedProduct = this.seedDoc(
                    this.documentsProvides,
                    true
                  );
                }
              }
              console.log(res);
            })
            .catch((error) => {
              reject(error);
            });
        });
      } catch (error) {
        alert(error);
      }
    },
    selectVictim(item) {
      this.victimsId = item._id;
      this.getOneVictimInfo();

      this.victimModal = {};
      this.initModalSinister();
      console.log(item, "okTest");

      //this.victimDialog = true;
    },

    // quoting
    async saveQuoting() {
      this.loading = true;

      try {
        const schema = {
          companies: defaultMethods.getItemsId(
            this.Companies.docs,
            this.quotingModal.companies
          ),
          product: defaultMethods.getItemId(
            this.File.proposedProducts,
            this.currentProduct
          ),
          duration: this.quotingModal.duration,
          netPrime: this.quotingModal.netPrime,
          TTCPrime: this.quotingModal.TTCPrime,
          annualRent: this.quotingModal.annualRent,
          // dateReturnCustomer: this.quotingModal.dateReturnCustomer,
          turnover: this.quotingModal.turnover,
          effective: this.quotingModal.effective,
          quality: this.quotingModal.quality,
          payroll: this.quotingModal.payroll,
          siteType: this.quotingModal.siteType,
          observation: this.quotingModal.observation,
          file: this.File._id,
        };

        if (this.quotingModal.dateReturnCustomer) {
          schema.dateReturnCustomer = this.quotingModal.dateReturnCustomer;
        }
        if (this.quotingModal._id) {
          // update
          await updateQuoting({
            schema,
            id: this.quotingModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeQuoting();
          this.initFile();
        } else {
          // add
          await addQuoting({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Appel")
          );
          this.closeQuoting();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    async saveCoupon() {
      this.loading = true;

      try {
        const schema = {
          // victim: this.victimModal._id,
          requestDate: this.couponModal.requestDate,
          couponReceptionDate: this.couponModal.couponReceptionDate,
          amount: this.couponModal.amount,
          observation: this.couponModal.observation,
        };

        await manageCoupon({
          schema,
          id: this.victimModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Coupon")
        );

        this.bonsDialog = false;
        this.initVictims();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    handleClickMailGed(item) {


      this.filesListe = item.victim_files;
      // alert(JSON.stringify(this.filesListe))
      // this.adnewObjectMail.mailID = item._id;
      // this.editedIndex = this.adnewObject.indexOf(item);
      // this.adnewObject = Object.assign({}, item);
      // alert(JSON.stringify(item));
      this.addFileMailGed = true;
    },
    async saveExpertise() {
      this.loading = true;

      try {
        const schema = {
          // victim: this.victimModal._id,
          dateRequestExpertise: this.expertiseModal.dateRequestExpertise,
          reportReceptionDate: this.expertiseModal.reportReceptionDate,
          expertName: this.expertiseModal.expertName,
          observation: this.expertiseModal.observation,
        };

        await manageExpertise({
          schema,
          id: this.victimModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Expertise")
        );

        this.expertiseDialog = false;
        this.initVictims();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async savePv() {
      this.loading = true;

      try {
        const schema = {
          // victim: this.victimModal._id,
          requestDatePv: this.pvModal.requestDatePv,
          policeStation: this.pvModal.policeStation,
          receptionDatePv: this.pvModal.receptionDatePv,
          locality: this.pvModal.locality,
          observation: this.pvModal.observation,
        };

        await managePv({
          schema,
          id: this.victimModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Pv")
        );

        this.pvDialog = false;
        this.initVictims();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async saveOffer() {
      this.loading = true;

      try {
        const schema = {
          // victim: this.victimModal._id,
          offerSendDate: this.offerModal.offerSendDate,
          inGameWarranty: this.offerModal.inGameWarranty,
          documentSendDate: this.offerModal.documentSendDate,
          PSAP: this.offerModal.PSAP,
          offerReceptDate: this.offerModal.offerReceptDate,
          aggreementReceptDate: this.offerModal.aggreementReceptDate,
          agreementTransmissionDate: this.offerModal.agreementTransmissionDate,
          checkReceiptDate: this.offerModal.checkReceiptDate,
          checkTransmissionDate: this.offerModal.checkTransmissionDate,
          receptDateReturn: this.offerModal.receptDateReturn,
          amount: this.offerModal.amount,
          status: this.offerModal.status,
          observation: this.offerModal.observation,
          franchise: this.offerModal.franchise,
          honorary: this.offerModal.honorary,
          checkNumber: this.offerModal.checkNumber,
          bank: this.offerModal.bank,
        };

        await manageOffer({
          schema,
          id: this.victimModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Offre")
        );

        this.offresDialog = false;
        this.initVictims();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    closeQuoting() {
      this.quotingModal = {};
      this.quotingDialog = false;
      // this.currentProduct = null;
    },
    async initQuoting() {
      try {
        this.loading = true;

        await this.getQuoting({
          product: defaultMethods.getItemId(
            this.File.proposedProducts,
            this.currentProduct
          ),
        });
        this.loading = false;
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },

    select_value() {
      // get quoting
      this.initQuoting();
      // get guarentie
      // get contract
    },

    // contract
    async seedContract() {
      this.loading = true;
      try {
        if (this.File && this.File._id && this.currentProduct) {
          await this.getContract({
            id: this.File._id,
            product: this.currentProduct,
            // product: defaultMethods.getItemId(
            //   this.File.proposedProducts,
            //   this.currentProduct
            // ),
          });
        } else {
          this.Contract = {};
          this.contractModal = {};
        }
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    seed50Accessory() {
      if (
        this.contractModal.accessory100 &&
        Number(this.contractModal.accessory100) > 0
      ) {
        this.contractModal.accessory50 = this.contractModal.accessory100 / 2;
      }
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          // commercial: defaultMethods.getItemId(
          //   this.Users.docs,
          //   this.contractModal.commercial
          // ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        // if (this.contractModal._id) {
        //   // update
        //   await updateContract({
        //     schema,
        //     id: this.contractModal._id,
        //   });
        //   defaultMethods.dispatchSuccess(
        //     this.$store,
        //     messages.updatedSuccessfully("Contract")
        //   );
        //   this.closeContract();
        //   this.initFile();
        // } else {
        // add
        schema.product = this.currentProduct;
        // schema.product = defaultMethods.getItemId(
        //   this.File.proposedProducts,
        //   this.currentProduct
        // );
        schema.file = this.File._id;
        await addContract({ schema, id: this.$route.params.id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Contract")
        );
        this.closeContract();
        this.initFile();
        // }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeClause() {
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    closeContract() {
      this.contractDialog = false;
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      // this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },

    // incorporation
    async saveIncorporation() {
      this.loading = true;
      try {
        // add

        await addIncorporation({
          schema: {
            contract: this.contractModal._id,
            prospect: this.incorporationModal,
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // retrait
    async makeWithDraw() {
      this.loading = true;
      try {
        await withdrawProspect({
          schema: {
            contract: this.contractModal._id,
            prospect: defaultMethods.getItemId(
              this.File.prospects,
              this.incorporationModal.name
            ),
          },
          id: this.File._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.createdSuccessfully("Incorporation")
        );
        this.closeContract();
        this.initFile();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    async saveRegulation() {
      this.loading = true;
      try {
        const schema = {
          plate: this.regulationClauseModal.plate,
          reminderDate: this.regulationClauseModal.reminderDate,
          observation: this.regulationClauseModal.observation,
          companyRequestDate: this.regulationClauseModal.companyRequestDate,
          companyReturnDate: this.regulationClauseModal.companyReturnDate,
          customerRequestDate: this.regulationClauseModal.customerRequestDate,
          customerReturnDate: this.regulationClauseModal.customerReturnDate,
        };

        if (this.regulationClauseModal._id) {
          // update
          await updateRegulationClause({
            schema,
            id: this.regulationClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addRegulationClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async savePb() {
      this.loading = true;
      try {
        const schema = {
          plate: this.pbClauseModal.plate,
          reminderDate: this.pbClauseModal.reminderDate,
          observation: this.pbClauseModal.observation,
          companyRequestDate: this.pbClauseModal.companyRequestDate,
          companyReturnDate: this.pbClauseModal.companyReturnDate,
          customerRequestDate: this.pbClauseModal.customerRequestDate,
          customerReturnDate: this.pbClauseModal.customerReturnDate,
        };

        if (this.pbClauseModal._id) {
          // update
          await updatePbClause({
            schema,
            id: this.pbClauseModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        } else {
          // add

          await addPbClause({ schema, id: this.contractModal._id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showCallEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.callModal = {
          _id: event._id,
          reason: event.name,
          hour: event.hour,
          date: event.start,
        };
        // this.ModalText = {
        //   btn: "update",
        //   title: `Update ${this.program.type}`,
        // };
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.callDialog = true))
        );
      };

      if (this.callDialog) {
        this.closeCall();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    getCallEvent() {
      this.events = [];

      if (!this.File || !this.File.otherInfo || !this.File.otherInfo.calls)
        return;
      for (let i = 0; i < this.File.otherInfo.calls.length; i++) {
        const program = this.File.otherInfo.calls[i];
        const date = new Date(`${program.date}`);
        const hours = program.hour.split(":");
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        this.events.push({
          name: program.reason,
          start: date,
          end: date,
          color: "red",
          timed: true,
          hour: program.hour,
          _id: program._id,
        });
      }
    },

    // appointment
    showAppointmentEvent({ nativeEvent, event }) {
      const edit = async () => {
        this.appointmentModal = {
          _id: event._id,
          reason: event.name,
          hour: event.hour,
          location: event.location,
          date: event.start,
        };

        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.appointmentAddDialog = true))
        );
      };

      if (this.appointmentAddDialog) {
        this.closeAppointment();
        requestAnimationFrame(() => requestAnimationFrame(() => edit()));
      } else {
        edit();
      }

      nativeEvent.stopPropagation();
    },
    closeAppointment() {
      this.appointmentModal = {};
      this.appointmentAddDialog = false;
      this.appointmentDialog = false;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getAppointmentEvent() {
      this.appointmentEvents = [];

      if (
        !this.File ||
        !this.File.otherInfo ||
        !this.File.otherInfo.appointments
      )
        return;
      for (let i = 0; i < this.File.otherInfo.appointments.length; i++) {
        const program = this.File.otherInfo.appointments[i];
        const date = new Date(`${program.date}`);
        const hours = program.hour.split(":");
        date.setHours(hours[0]);
        date.setMinutes(hours[1]);
        this.appointmentEvents.push({
          name: program.reason,
          start: date,
          end: date,
          color: "blue",
          timed: true,
          hour: program.hour,
          location: program.location,
          _id: program._id,
        });
      }
    },
    async saveAppointment() {
      this.loading = true;
      try {
        if (this.appointmentModal._id) {
          // update
          await updateAppointment({
            schema: {
              reason: this.appointmentModal.reason,
              hour: this.appointmentModal.hour,
              date: this.appointmentModal.date,
              location: this.appointmentModal.location,
            },
            id: this.appointmentModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeAppointment();
          this.initFile();
        } else {
          // add
          await addAppointment({
            schema: this.appointmentModal,
            id: this.$route.params.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Rendez-vous")
          );
          this.closeAppointment();

          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    getProposedData(data, value, third = undefined) {
      const schema = [];
      for (let i = 0; i < data.length; i++) {
        if (third != undefined) {
          let isProvide = false;
          for (let a = 0; a < third.length; a++) {
            if (third[a]._id == data[i]._id) {
              isProvide = true;
              break;
            }
          }

          schema.push({
            isProvide,
            document: data[i]._id,
          });
        } else {
          schema.push({
            isProvide: value,
            document: data[i]._id,
          });
        }
      }
      return schema;
    },
    searchDataProduct() {
      this.initDeclaration();
    },
    async proposedDocuments() {
      try {
        const schema = this.getProposedData(this.selectedDocumentsModal, false);
        await manageDocumentProposed({
          id: this.victimModal._id,
          schema: { list: schema },
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Document")
        );
        //this.productDialog = false;
        this.initVictims();
        this.getOneVictimInfo();
        this.initDeclaration();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
    },
    async providedDocuments() {
      try {
        const schema = this.getProposedData(
          this.documentsProvides,
          true,
          this.selectedProduct
        );
        await manageDocumentProposed({
          id: this.victimModal._id,
          schema: { list: schema },
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Document")
        );
        //this.productDialog = false;
        this.initVictims();
        this.getOneVictimInfo();
        this.initDeclaration();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
    },
    // proposed product
    async updateProposedProduct() {
      try {
        const schema = {
          schema: {
            name: this.File.name,
            prospects: this.File.prospects,
            phone: this.File.phone,
            email: this.File.email,
            nature: this.File.nature,
            location: this.File.location,
            description: this.File.description,
            activityField: this.File.activityField,
            birthday: this.File.birthday,
            proposedProducts: defaultMethods.getIdList(this.selectedProduct),
          },
          id: this.File._id,
        };

        await updateFile(schema);
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Dossier")
        );
        //this.closeProduct();
        this.initVictims();
        this.getOneVictimInfo();
        this.initFile();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
    },
    closeProduct() {
      this.productDialog = false;
      this.selectedProduct = {};
    },

    seedProposedProduct() {
      this.selectedProduct = this.File.proposedProducts;
      this.proposedProductNameList = defaultMethods.getNameList(
        this.File.proposedProducts
      );
    },

    // coinsurance
    seedCoinsuranceCompanyNameList() {
      this.coinsuranceCompanyNameList = defaultMethods.getNameList(
        this.Companies.docs
      );
    },
    updateCoinsuranceCompanyNameList() {
      // seed
      this.seedCoinsuranceCompanyNameList();
      console.log("here", this.coinsuranceModal);
      for (let a = 0; a < this.coinsuranceModal.lenght; a++) {
        const coinsurance = this.coinsuranceModal[a];
        for (let i = 0; i < this.coinsuranceCompanyNameList.lenght; i++) {
          console.log(coinsurance.company, this.coinsuranceCompanyNameList[i]);
          if (coinsurance.company == this.coinsuranceCompanyNameList[i])
            this.coinsuranceCompanyNameList.splice(i, 1);
        }
      }
    },
    addOneCoinsurance() {
      this.coinsuranceModal.push({});
    },
    closeInsurance() {
      this.coinsuranceDialog = false;
      // this.currentProduct = null;
      this.contractDialog = false;

      this.coinsuranceModal = [
        {
          shareRate: 0,
          company: "",
          observation: "",
        },
      ];
      this.seedCoinsuranceCompanyNameList();
    },

    validCoinsuranceData(array) {
      const result = [];
      let totalRate = 0;

      const companyList = [];
      for (let i = 0; i < array.length; i++) {
        const item = array[i];

        // body validation

        // rate
        totalRate += Number(item.shareRate);

        // company
        if (companyList.includes(JSON.stringify(item.company)))
          throw new Error(
            `Duplicate company id  :${item.company} for coinsurance`
          );
        companyList.push(JSON.stringify(item.company));

        // get company id
        (item.company = defaultMethods.getItemId(
          this.Companies.docs,
          item.company
        )),
          result.push({
            shareRate: item.shareRate,
            company: item.company,
            isPayed: item.isPayed,
            observation: item.observation,
          });
      }

      if (totalRate !== 100)
        return {
          success: false,
          message: `Total shared rate must be 100,got ${totalRate}`,
        };

      return {
        success: true,
        data: result,
      };
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },
    updateprospect(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.prospect = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>

</style>
